import React from "react";
import { useNavigate } from "react-router-dom";
export default function CheckEmailModal({ cancelModal }) {
  const navi = useNavigate();
  //styled
  const handleClick = () => {
    cancelModal();
    navi("/");
  };

  return (
    <div className="send-modal-overlay">
      <div className="send-modal">
        <div className="blueBanner">
          <p className="fw-bold m-2 p-2 fontSize20">Verify Email</p>
        </div>
        <p>
          An email has been sent to your address for verification. Please check
          your inbox. If you don't see it, please check your junk or spam
          folder.
        </p>

        <div className="send-modal-footer">
          <button
            className="pointer cancelButton fw-bold mx-2 px-3"
            onClick={handleClick}
          >
            Okay
          </button>
        </div>
      </div>
    </div>
  );
}
